import CalendarDay from "./SVG/calendarDay.svg?react";

const CalendarDayIcon = () => {
  return <CalendarDay />;
};

export default CalendarDayIcon;
